import React from 'react';
const steps = ['CATEQUESIS 1', 'CATEQUESIS 2', 'CONFIRMACIÓN'];
export function SolutionSection() {
  return <section className="py-10 px-4 bg-gray-50" data-id="element-152" data-mp="3aaaxg96qb565">
      <div className="max-w-3xl mx-auto text-center" data-id="element-153" data-mp="3abm0u7w9iawq">
        <p className="text-xs font-black tracking-wider text-[#157C8B] mb-2" data-id="element-154" data-mp="3oabutensbugv">
          LA SOLUCIÓN
        </p>
        <h2 className="text-[20px] md:text-2xl font-black text-[#14356B] mb-4 leading-tight" data-id="element-155" data-mp="3j9fu19yqcofo">
          UN RECORRIDO COMPLETO DE CATEQUESIS CON ACTIVIDADES LISTAS PARA USAR
        </h2>

        <p className="text-base text-gray-700 mb-5" data-id="element-156" data-mp="3t7c37w83x9b5">
          <strong className="text-[#14356B]" data-id="element-157" data-mp="3t6ken5cxgbud">CATEQUESIS LISTAS</strong> reúne
          120 páginas distribuidas en 3 materiales que acompañan distintas
          etapas del camino de fe:
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-5" data-id="element-158" data-mp="5xnkgu84l6rv">
          {steps.map((step, index) => <React.Fragment key={step} data-id="element-159" data-mp="ftgzqld8bedc" data-mpi={index}>
              {index > 0 && <span className="text-[#157C8B] font-black" aria-hidden="true" data-id="element-160" data-mp="fv1zcpeehni2">
                  →
                </span>}
              <span className="bg-white border border-[#B8DCE0] text-[#14356B] text-xs font-black px-3 py-1.5 rounded-full" data-id="element-161" data-mp="36cp32vzhe1kt">
                {step}
              </span>
            </React.Fragment>)}
        </div>

        <p className="text-base text-gray-700 mb-4" data-id="element-162" data-mp="3fdn3736stoy4">
          No son solamente textos para leer. Cada material combina explicaciones
          sencillas, imágenes, situaciones cotidianas, actividades, preguntas,
          momentos de reflexión y propuestas para relacionar la fe con la propia
          vida.
        </p>

        <p className="text-lg font-black text-[#14356B]" data-id="element-163" data-mp="2tdlv1hpnw8p">
          🖨️ Descargás, imprimís y aplicás.
        </p>
      </div>
    </section>;
}